<script setup lang="ts">
import FooterItem from '@fondof-ui/components/footer/FooterItem.vue'
import FooterMarkdownContent from '@fondof-ui/components/footer/FooterMarkdownContent.vue'
import FooterHeadline from '@satch-ui/components/footer/FooterHeadline.vue'
import { footerMarkdownVariants } from '@satch-ui/components/footer/variants'
import { t } from '@satch-ui/translations/translations'

const props = defineProps<{
  id: string
  content: string
}>()
</script>
<template>
  <div
    :data-cfid="props.id"
    class="row-start-3 mb-6 md:col-start-[second-col] md:row-start-[first-row] md:mb-0"
  >
    <FooterItem disabled>
      <template #headline="{ disabled }">
        <FooterHeadline
          :headline="t('footer.contact')"
          variant="black"
          :disabled="disabled"
        />
      </template>
      <template #content>
        <FooterMarkdownContent
          :class="footerMarkdownVariants({ color: 'black' })"
          :content="props.content"
        />
      </template>
    </FooterItem>
  </div>
</template>
